// Use $ instead of $ without replacing global $
(function ($) {
  $(document).ready(function () {
    $(document).on("click", ".form-open", function (e) {
      e.preventDefault();
      $(".form-overlay").addClass("active");
      $("body").css("overflow", "hidden");
      $(".form-overlay").css({ display: "block", visibility: "visible" });
    });
    $(".form-overlay .closeVideo, .form-overlay").click(function () {
      $(".form-overlay").removeClass("active");
      $(".form-overlay").css({ display: "none", visibility: "hidden" });
      $("body").css("overflow", "inherit");
    });
    $(".form-overlay .video-container").click(function (e) {
      e.stopPropagation();
    });
  });
})(jQuery);
